import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ServiceSingle, FooterTwo } from "../containers";

const serviceContent = {
  topImage: "/images/service/sr-d-1-1.jpg",
  heading: "Web Development",
  description: `Our Web Development services empower businesses to establish a strong and scalable online presence. 
  We design and develop responsive, SEO-optimized, and performance-driven websites that deliver exceptional user experiences. 
  Whether you need a corporate website, an eCommerce platform, or a custom web solution, our team ensures clean coding practices, 
  cross-browser compatibility, and future-ready architecture tailored to your business goals.`,

  middleImage: "/images/service/sr-d-1-2.jpg",
  features: [
    "Responsive & Mobile-First Design",
    "SEO-Optimized Development",
    "Custom Frontend & Backend Solutions",
    "Scalable & Secure Architecture",
    "Performance & Speed Optimization"
  ],

  challengeHeading: "Challenges in Web Development",
  challengeParagraphs: [
    `Delivering websites that work seamlessly across all devices, browsers, and operating systems requires a careful blend of technical expertise and creativity. 
    Issues like security vulnerabilities, poor scalability, and inconsistent performance can limit growth if not addressed properly.`,
    `At Tech Ayukta, we overcome these challenges using best practices, modern frameworks, and robust testing. 
    We ensure your website is not only visually appealing but also reliable, secure, and optimized for long-term success.`
  ],

  bottomImages: [
    "/images/service/sr-d-1-3.jpg",
    "/images/service/sr-d-1-4.jpg"
  ]
};

const WebDevelopment = () => (
  <Fragment>
    <Seo
      title="Web Development Services | Tech Ayukta"
      description="Tech Ayukta provides professional web development services, building responsive, SEO-friendly, and scalable websites tailored to your business."
      keywords="Web Development, Website Design, Custom Web Development, eCommerce Development, React, Node.js, Tech Ayukta"
      canonical="https://www.techayukta.com/services/web-development"
    />
    <HeaderThree />
    <Breadcrumb pageName="Web Development" bgImage="/images/breadcumb/breadcumb-bg.jpg" />
    <ServiceSingle
      className="space-top space-extra-bottom"
      serviceContent={serviceContent}
    />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default WebDevelopment;
